module.exports = __webpack_public_path__ + "static/img/Roblox.36ce5adb.png";